export class MoveDraftFileInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "fromPath",
            "baseName": "fromPath",
            "type": "string",
            "format": ""
        },
        {
            "name": "toPath",
            "baseName": "toPath",
            "type": "string",
            "format": ""
        },
        {
            "name": "message",
            "baseName": "message",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return MoveDraftFileInput.attributeTypeMap;
    }
    constructor() {
    }
}
